import React from 'react';
import { useWindowSize } from '@Components/Utilities/WindowSize';
import HamburgerMenu from '@Components/Header/HamburgerMenu';

const HeaderLogoView = (props) => {

    const windowSize = useWindowSize();

    return (
        <>
            <div className='site-header no-print'>
                <div className='middle-row'>
                    <div className='middle-row-content'>
                        <div className='logo'>
                            <a href={props.HomeUrl} className='main-logo-link'>
                                <img className='main-logo' alt={props.LogoImageAltText} src={props.LogoUrl} />
                            </a>
                        </div>
                        {windowSize.isMobile && <HamburgerMenu {...props} />}
                    </div>
                </div>
            </div>
        </>
    );
}

export default HeaderLogoView;
global.HeaderLogoView = HeaderLogoView;